import { useMemo } from "react";
import {
  PresenceTableName,
  useDynamoDeleteItem,
  useDynamoMutateItem,
  useDynamoQuery,
} from "../../services/dynamo";
import type { VehiclePlate } from "../../types/user";

export function useVehiclePlates(userId: string | undefined) {
  const command = useMemo(
    () => ({
      TableName: PresenceTableName,
      KeyConditionExpression: "#pk = :pk AND begins_with(#sk, :sk)",
      ExpressionAttributeValues: {
        ":pk": userId ?? "",
        ":sk": "vehiclePlate#",
      },
      ExpressionAttributeNames: {
        "#pk": "pk",
        "#sk": "sk",
      },
    }),
    [userId],
  );

  return useDynamoQuery<VehiclePlate>(command, {
    enabled: !!userId,
  });
}

export function useSaveVehiclePlate() {
  return useDynamoMutateItem<VehiclePlate>(PresenceTableName, {});
}

export function useDeleteVehiclePlate() {
  return useDynamoDeleteItem(PresenceTableName, {});
}
